import { IResponse } from "models";

export enum ActionType {
  // download PDF file TypeInfo list
  MINI_STRESS_TYPE_DOWNLOAD_CSV = "action/MINI_STRESS_TYPE_DOWNLOAD_CSV",
  MINI_STRESS_TYPE_DOWNLOAD_CSV_SUCCESS = "action/MINI_STRESS_TYPE_DOWNLOAD_CSV_SUCCESS",
  MINI_STRESS_TYPE_DOWNLOAD_CSV_ERROR = "action/MINI_STRESS_TYPE_DOWNLOAD_CSV_ERROR",
  MINI_STRESS_TYPE_DOWNLOAD_CSV_RESET_DATA = "action/MINI_STRESS_TYPE_DOWNLOAD_CSV_RESET_DATA",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface MiniStressTypeCSVDownloadResponse extends IResponse {
  result?: ICSVDownloadResult;
}

export interface ICSVDownloadResult {
  data: ICSVDownloadMiniStressTypeItem[];
  headers: IHeaderCSVDownloadMiniStressTypeItem[];
}
export interface IMiniStressTypeDownloadCsvData {
  not_implement: boolean;
  start_date?: string;
  end_date?: string;
  need_attention: boolean;
  high_stress_1: boolean;
  high_stress_2: boolean;
}

export interface IHeaderCSVDownloadMiniStressTypeItem {
  label: string;
  key: string;
}

export interface ICSVDownloadMiniStressTypeItem {
  name: string;
  date_of_implementation: string;
  stress_situation: string;
  status: string;
  interview_transmission_status: string;
  B: string;
  A_C: string;
  affiliation: string;
  gender: string;
}
